
export const AnybillApiPaths = {
    GET_CUSTOMERS: `/api/proxy/v1/customer`,
    GET_VENDOR_INFORMATION: (identifier: string) => `/api/proxy/v1/customer/${identifier}`,
    FIND_RECEIPT: `/api/proxy/v1/bill/find`
}